import React, { useState } from 'react';
import type { FC } from 'react';

import { BrokenThumbnailIcon } from '@/common/broken-thumbnail-icon';

export interface CreativeThumbnailProps {
    thumbnail?: string;
}

export const CreativeThumbnail: FC<CreativeThumbnailProps> = ({ thumbnail }) => {
    const [thumbnailLoadFailed, setThumbnailLoadFailed] = useState(false);

    return (
        <div className="w-16 chess-xs">
            {thumbnailLoadFailed || !thumbnail ? (
                <div className="w-full aspect-square flex items-center justify-center">
                    <BrokenThumbnailIcon className="w-2/3 h-2/3" />
                </div>
            ) : (
                <img
                    alt="Creative thumbnail"
                    className="w-16 aspect-square rounded-md p-1"
                    src={thumbnail}
                    onError={(e) => {
                        setThumbnailLoadFailed(true);
                    }}
                />
            )}
        </div>
    );
};
